import {vuex as catalogo} from './catalogo'
import {vuex as atendimento} from './atendimento'
import {vuex as pagina_cliente} from './pagina-cliente'

export default { catalogo, atendimento, pagina_cliente}